import { render, staticRenderFns } from "./v-pop-reg.vue?vue&type=template&id=f29b57b8"
import script from "./v-pop-reg.vue?vue&type=script&lang=js"
export * from "./v-pop-reg.vue?vue&type=script&lang=js"
import style0 from "./v-pop-reg.vue?vue&type=style&index=0&id=f29b57b8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports